import { Component, Input, OnDestroy } from '@angular/core';
import { LookupService } from '@app/core/services/lookup/lookup.service';
import { IDesignSchemeMappedItem } from '@app/logic/design-schemes';
import moment from 'moment';
import { Subscription, take } from 'rxjs';

@Component({
    selector: 'cb-design-scheme-side-bar-card',
    templateUrl: './side-bar-card.component.html',
    styleUrls: ['./side-bar-card.component.scss'],
    standalone: false
})
export class DesignSchemeSideBarCardComponent implements OnDestroy {
    private sub$ = new Subscription();
    private _mappedItem: IDesignSchemeMappedItem;
    @Input() public set mappedItem(item: IDesignSchemeMappedItem) {
        this._mappedItem = item;
        this.sub$.unsubscribe();
        if (this.mappedItem) {
            this.sub$ = this.mappedItem.$updated.subscribe(() => {
                this.pollElapsedTime();
            });
        }
    }
    public get mappedItem(): IDesignSchemeMappedItem {
        return this._mappedItem;
    }

    public designComplexities = this.lookups.DESIGN_COMPLEXITY.toLookup();
    public clientsideElapsedTimeDuration: any = {};
    public durationText: string;
    private elapsedTimeDuration = moment.duration();
    private dateTimeLastPolled = moment();

    constructor(
        private readonly lookups: LookupService,
    ) { }

    public ngOnDestroy(): void {
        this.sub$.unsubscribe();
    }

    // Get initial calculated elapsed time from the server.
    private pollElapsedTime = (): void => {
        this.mappedItem.getElapsedTime().pipe(take(1)).subscribe((result) => {
            this.dateTimeLastPolled = moment();

            const durationText = result.toString().replace(/\"/g, '');
            this.elapsedTimeDuration = moment.duration(durationText);
            setTimeout(this.updateElapsedTimeClientside, 1000);
        });
    };

    /* Calulate the elapsed time on clientside to avoid constant polling serverside */
    private updateElapsedTimeClientside = (): void => {
        if (this.mappedItem.inProgress) {
            const dateNow = moment();
            // Calculates how long since the initial elapsed time was updated form the server-side
            // and add duration to now.
            const duration = moment.duration(dateNow.diff(this.dateTimeLastPolled));

            // Now add that duration to initial duration to get real-time duration.
            this.clientsideElapsedTimeDuration = moment.duration(this.elapsedTimeDuration);
            this.clientsideElapsedTimeDuration.add(duration.asSeconds(), 's');

            // set model to allow duration input control to format duration as required
            setTimeout(this.updateElapsedTimeClientside, 1000);
        } else {
            // since not in progress no further time is elapsing.
            this.clientsideElapsedTimeDuration = moment.duration(this.elapsedTimeDuration);
        }

        this.formatText();
    };


    public formatText(): void {
        if (this.clientsideElapsedTimeDuration !== undefined) {
            try {
                this.durationText = (Math.floor(this.clientsideElapsedTimeDuration.asHours())) + ':' +
                    moment(this.clientsideElapsedTimeDuration.asMilliseconds()).format('mm:ss').toString();
            } catch (error) {
                this.durationText = '';
            }
        } else {
            this.durationText = '';
        }

    }
}
